import track from '../lib/tracking/track';

const PAGE_LOCATION = 'signup_prompt_modal';

const modalCtaClickEvent = {
  eventName: 'cta_clicked',
  payload: {
    ctaType: 'primary',
    label: 'Get started for free',
    pageLocation: PAGE_LOCATION,
  },
};

const modalCloseClickEvent = {
  eventName: 'modal_dismissed',
  payload: {
    pageLocation: PAGE_LOCATION,
  },
};

const modalOpenedEvent = {
  eventName: 'modal_opened',
  payload: {
    pageLocation: PAGE_LOCATION,
  },
};

const trackCtaClick = () =>
  track(modalCtaClickEvent.eventName, modalCtaClickEvent.payload);
const toggleScroll = ({ visibility }) => {
  document.body.setAttribute('style', `overflow-y: ${visibility}`);
};

const getModalElements = () => {
  const getSignUpModal = () => {
    const signUpModalEl = document.getElementById('sign-up-modal');
    return () => signUpModalEl;
  };
  const signUpModal = getSignUpModal();

  const getSignUpModalCta = () => {
    let anchorEl = null;
    if (signUpModal()) {
      anchorEl = signUpModal().getElementsByTagName('a')[0];
    }
    return () => anchorEl;
  };
  const signUpCta = getSignUpModalCta();

  return {
    signUpModal,
    signUpCta,
  };
};

const openModal = (modalEls) => {
  toggleScroll({ visibility: 'hidden' });
  modalEls.signUpModal().setAttribute('open', true);
  modalEls.signUpCta().addEventListener('click', trackCtaClick);

  track(modalOpenedEvent.eventName, modalOpenedEvent.payload);
};

const closeModal = (modalEls) => {
  toggleScroll({ visibility: 'visible' });
  modalEls.signUpModal().setAttribute('open', false);
  modalEls.signUpCta().removeEventListener('click', trackCtaClick);

  track(modalCloseClickEvent.eventName, modalCloseClickEvent.payload);
};

document.addEventListener('DOMContentLoaded', () => {
  const modalEls = getModalElements();

  if (!modalEls.signUpModal()) return;

  modalEls.signUpModal().addEventListener('requestclose', () => {
    closeModal(modalEls);
  });

  const timeoutString = modalEls
    .signUpModal()
    .getAttribute('data-prompt-modal-timeout');
  setTimeout(() => openModal(modalEls), Number(timeoutString || 10000));
});
